import { render, staticRenderFns } from "./DanhSachDaiLy.vue?vue&type=template&id=ff2191e0&scoped=true&"
import script from "./DanhSachDaiLy.js?vue&type=script&lang=js&"
export * from "./DanhSachDaiLy.js?vue&type=script&lang=js&"
import style0 from "./DanhSachDaiLy.vue?vue&type=style&index=0&id=ff2191e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2191e0",
  null
  
)

/* custom blocks */
import block0 from "./DanhSachDaiLy.scss?vue&type=custom&index=0&blockType=link&issuerPath=C%3A%5Cvsts-agent%5C_work%5C49%5Cs%5Csrc%5Cviews%5Cadmin%5CDaiLy%5CDanhSachDaiLy%5CDanhSachDaiLy.vue&lang=scss"
if (typeof block0 === 'function') block0(component)

export default component.exports